<template>
    <div class="notice-header-wrap">
        <div class="notice-header">
            <div class="fst">
                <span>공지사항</span>
            </div>
            <div class="cst">
                <div class="notice-list-wrap" id="notice-list">
                    <p  v-for="notice, noticeIndex in noticeList"  :class="{'new':notice.newCheck}">{{notice.notice}}</p>
                </div>

            </div>
            <div class="lst"></div>

        </div>
    </div>
</template>

<script>

    export default{
        data(){
            return{
                noticeList: [
                    {notice: '공지사항1공지사항1공지사항1공지사항1공지사항1', newCheck: true},
                    {notice: '공지사항2', newCheck: false},
                    {notice: '공지사항3', newCheck: true},
                    {notice: '공지사항4', newCheck: false},
                    {notice: '공지사항5', newCheck: true},

                ],
                nowPosition: 0,
                maxPosition: 0
            }
        },
        methods:{
            nextNotice(){

              if(this.nowPosition === this.maxPosition){
                  $("#notice-list p").eq(0).css({top: '100%'});
                  $("#notice-list p").eq(this.nowPosition).animate({top: '-100%'}, 500);
                  $("#notice-list p").eq(0).animate({top: '0'}, 500);
                  this.nowPosition = 0;
              }else{

                  $("#notice-list p").eq((this.nowPosition+1)).css({top: '100%'});
                  $("#notice-list p").eq(this.nowPosition).animate({top: '-100%'}, 500);
                  $("#notice-list p").eq((this.nowPosition+1)).animate({top: '0'}, 500);
                  this.nowPosition++;
              }




          }
        },
        mounted(){

            this.maxPosition =  $("#notice-list p").length-1
            const _this = this;
            $("#notice-list p").eq(0).css({top: '0'});
            this.nextNoticeInterval = setInterval(function () {
                _this.nextNotice()
            }, 3000)
        },
        destroyed: function(){
            clearInterval(this.nextNoticeInterval)
        }
    }
</script>
